"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFetchEndInstrumentationHandler = addFetchEndInstrumentationHandler;
exports.addFetchInstrumentationHandler = addFetchInstrumentationHandler;
exports.parseFetchArgs = parseFetchArgs;

var _is = require("../is.js");

var _object = require("../object.js");

var _supports = require("../supports.js");

var _time = require("../time.js");

var _worldwide = require("../worldwide.js");

var _handlers = require("./handlers.js");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
  const type = 'fetch';
  (0, _handlers.addHandler)(type, handler);
  (0, _handlers.maybeInstrument)(type, () => instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */


function addFetchEndInstrumentationHandler(handler) {
  const type = 'fetch-body-resolved';
  (0, _handlers.addHandler)(type, handler);
  (0, _handlers.maybeInstrument)(type, () => instrumentFetch(streamHandler));
}

function instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
  if (skipNativeFetchCheck && !(0, _supports.supportsNativeFetch)()) {
    return;
  }

  (0, _object.fill)(_worldwide.GLOBAL_OBJ, 'fetch', function (originalFetch) {
    return function (...args) {
      // We capture the error right here and not in the Promise error callback because Safari (and probably other
      // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
      // NOTE: If you are a Sentry user, and you are seeing this stack frame,
      //       it means the error, that was caused by your fetch call did not
      //       have a stack trace, so the SDK backfilled the stack trace so
      //       you can see which fetch call failed.
      const virtualError = new Error();

      const _parseFetchArgs = parseFetchArgs(args),
            method = _parseFetchArgs.method,
            url = _parseFetchArgs.url;

      const handlerData = {
        args,
        fetchData: {
          method,
          url
        },
        startTimestamp: (0, _time.timestampInSeconds)() * 1000,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError
      }; // if there is no callback, fetch is instrumented directly

      if (!onFetchResolved) {
        (0, _handlers.triggerHandlers)('fetch', _objectSpread({}, handlerData));
      } // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access


      return originalFetch.apply(_worldwide.GLOBAL_OBJ, args).then(async response => {
        if (onFetchResolved) {
          onFetchResolved(response);
        } else {
          (0, _handlers.triggerHandlers)('fetch', _objectSpread(_objectSpread({}, handlerData), {}, {
            endTimestamp: (0, _time.timestampInSeconds)() * 1000,
            response
          }));
        }

        return response;
      }, error => {
        (0, _handlers.triggerHandlers)('fetch', _objectSpread(_objectSpread({}, handlerData), {}, {
          endTimestamp: (0, _time.timestampInSeconds)() * 1000,
          error
        }));

        if ((0, _is.isError)(error) && error.stack === undefined) {
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the error, that was caused by your fetch call did not
          //       have a stack trace, so the SDK backfilled the stack trace so
          //       you can see which fetch call failed.
          error.stack = virtualError.stack;
          (0, _object.addNonEnumerableProperty)(error, 'framesToPop', 1);
        } // NOTE: If you are a Sentry user, and you are seeing this stack frame,
        //       it means the sentry.javascript SDK caught an error invoking your application code.
        //       This is expected behavior and NOT indicative of a bug with sentry.javascript.


        throw error;
      });
    };
  });
}

async function resolveResponse(res, onFinishedResolving) {
  if (res && res.body) {
    const body = res.body;
    const responseReader = body.getReader(); // Define a maximum duration after which we just cancel

    const maxFetchDurationTimeout = setTimeout(() => {
      body.cancel().then(null, () => {// noop
      });
    }, 90 * 1000 // 90s
    );
    let readingActive = true;

    while (readingActive) {
      let chunkTimeout;

      try {
        // abort reading if read op takes more than 5s
        chunkTimeout = setTimeout(() => {
          body.cancel().then(null, () => {// noop on error
          });
        }, 5000); // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`

        const _await$responseReader = await responseReader.read(),
              done = _await$responseReader.done;

        clearTimeout(chunkTimeout);

        if (done) {
          onFinishedResolving();
          readingActive = false;
        }
      } catch (error) {
        readingActive = false;
      } finally {
        clearTimeout(chunkTimeout);
      }
    }

    clearTimeout(maxFetchDurationTimeout);
    responseReader.releaseLock();
    body.cancel().then(null, () => {// noop on error
    });
  }
}

function streamHandler(response) {
  // clone response for awaiting stream
  let clonedResponseForResolving;

  try {
    clonedResponseForResolving = response.clone();
  } catch (e) {
    return;
  } // eslint-disable-next-line @typescript-eslint/no-floating-promises


  resolveResponse(clonedResponseForResolving, () => {
    (0, _handlers.triggerHandlers)('fetch-body-resolved', {
      endTimestamp: (0, _time.timestampInSeconds)() * 1000,
      response
    });
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!obj[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */


function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return {
      method: 'GET',
      url: ''
    };
  }

  if (fetchArgs.length === 2) {
    const _fetchArgs = _slicedToArray(fetchArgs, 2),
          url = _fetchArgs[0],
          options = _fetchArgs[1];

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
  };
}